import * as React from 'react';

import { IMediaItem } from '../../types/newbuildingTiledCarousel';
import { BookedOverlay } from './BookedOverlay';
import { ImageTile } from './ImageTile/ImageTile';
import * as styles from './styles.css';

interface INewbuildingTiledCarousel {
  images: IMediaItem[];
  counter: React.ReactNode;
  promo: React.ReactNode;
  tour: React.ReactNode;
  isBooked: boolean;
  onClick(slideIndex: number): void;
}

export const NewbuildingTiledCarousel = (props: INewbuildingTiledCarousel) => {
  const onSliderClick = (index: number) => () => {
    props.onClick(index + 1);
  };

  return (
    <div data-name="NewbuildingTiledCarousel" className={styles['container']}>
      <div className={styles['carousel']}>
        <div className={styles['square']}>
          <div className={styles['item']}>
            {props.images[0] && (
              <ImageTile
                onClick={onSliderClick(0)}
                fullUrl={props.images[0].fullUrl}
                isLayout={props.images[0].isLayout}
                isFloorPlan={props.images[0].isFloorPlan}
                polygonPath={props.images[0].polygonPath}
              />
            )}
            {props.isBooked && (
              <div className={styles['booked']} onClick={onSliderClick(0)}>
                <BookedOverlay />
              </div>
            )}
          </div>
        </div>
        <div className={styles['column']}>
          <div className={styles['item']}>
            {props.images[1] && (
              <ImageTile
                onClick={onSliderClick(1)}
                fullUrl={props.images[1].fullUrl}
                isLayout={props.images[1].isLayout}
                isFloorPlan={props.images[1].isFloorPlan}
                polygonPath={props.images[1].polygonPath}
              />
            )}
          </div>

          <div className={styles['item']}>
            {props.images[2] && (
              <ImageTile
                onClick={onSliderClick(2)}
                fullUrl={props.images[2].fullUrl}
                isLayout={props.images[2].isLayout}
                isFloorPlan={props.images[2].isFloorPlan}
                polygonPath={props.images[2].polygonPath}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles['counter']}>{props.counter}</div>
      <div className={styles['tour']}>{props.tour}</div>
      {props.promo}
    </div>
  );
};

NewbuildingTiledCarousel.displayName = 'NewbuildingTiledCarousel';
